export const PageDataState = {
    Searchs: {
        type_a_academy_id: {
            type: 'text',
            id: 'type_a_academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา'
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primary',
                required: false
            },
            error: { status: null, msg: '' }
        },
        type_a_academy_id: {
            type: 'text',
            id: 'type_a_academy_id',
            label: 'รหัสสถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        types: {
            type: 'select',
            id: 'types',
            label: 'ประเภท',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },      
        years: {
            type: 'select',
            id: 'years',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'สถานประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },   
        scholarship_flag: {
            type: 'checkbox',
            group: 'none',
            id: 'scholarship_flag',
            label: 'ได้รับทุนการศึกษา',
            value: '',
            placeholder: 'ได้รับทุนการศึกษา',
            validator:{
                type: 'checkbox',
                required: false
            },
            error: { status: null, msg: '' }            
        }, 
        scholarship_value: {
            type: 'text',
            id: 'scholarship_value',
            label: 'จำนวน',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 100,
                max: 500000
            },
            error: { status: null, msg: '' }
        },  
        job_start_date: {
            type: 'text',
            id: 'job_start_date',
            label: 'วันที่เริ่มทำงาน',
            value: '',
            validator: {
                type: 'date',
                required: false
            },
            error: { status: null, msg: '' }
        }, 
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่งงาน',
            value: '',
            validator: {
                type: 'text',
                required: false,
                min: 3,
                max: 255
            },
            error: { status: null, msg: '' }
        },          
        salary_range_start: {
            type: 'text',
            id: 'salary_range_start',
            label: 'เงินเดือน เริ่มต้น',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 100,
                max: 500000
            },
            error: { status: null, msg: '' }
        },     
        salary_range_end: {
            type: 'text',
            id: 'salary_range_end',
            label: 'ถึง',
            value: '',
            validator: {
                type: 'number',
                required: false,
                min: 100,
                max: 500000
            },
            error: { status: null, msg: '' }
        },                             
    },
    InputGroup: {
        Checkbox: {
            none: {
                display: 'inline',
                label: undefined,
                inputs: [
                    {id: 'scholarship_flag', value: '1'},
                ],
                validator: {
                    type: 'checkbox',
                    required: false,
                },
                error: { status: null, msg: '' },
            }           
        }        
    },
}